import { getAuthToken, saveAuthToken } from '@/utils/token'
import { State } from '@/utils/interfaces'

export const SET_AUTH_TOKEN = 'setAuthToken'

export const getters = {
  authToken: (state: State): string | null => {
    if (state.authToken) {
      return state.authToken;
    } else {
      return getAuthToken();
    }
  },
};

export const mutations = {
  [SET_AUTH_TOKEN](state: State, authToken: string): void {
    state.authToken = authToken;
    if (authToken) saveAuthToken(authToken);
  },
};

export default {
  namespaced: true,
  state: {
    authToken: getAuthToken(),
  },
  getters: getters,
  mutations: mutations
}
